module.exports = __webpack_public_path__ + "static/media/UniNeueLight-Italic.9462bdf1.ttf";